{
	"handles": {
		"AR": "ChangeorgAR",
		"AU": "ChangeAUS",
		"BO": "ChangeorgLatino",
		"BR": "change_br",
		"BY": "changeorgrus",
		"CA": "CdnChange",
		"CL": "ChangeorgChile",
		"CO": "ChangeorgCO",
		"CR": "ChangeOrgCentro",
		"CU": "ChangeorgLatino",
		"DE": "ChangeGER",
		"DO": "ChangeOrgCentro",
		"EC": "ChangeorgLatino",
		"ES": "change_es",
		"FR": "ChangeFrance",
		"GB": "UKChange",
		"GG": "UKChange",
		"GI": "UKChange",
		"GT": "ChangeOrgCentro",
		"HN": "ChangeOrgCentro",
		"ID": "ChangeOrg_ID",
		"IM": "UKChange",
		"IN": {
			"handle": "ChangeOrg_India",
			"localesOverrides": {
				"hi-IN": "ChangeOrg_Hindi"
			}
		},
		"IT": "ChangeItalia",
		"JE": "UKChange",
		"KE": "ChangeOrgKE",
		"JP": "change_jp",
		"MX": "Change_Mex",
		"MY": "ChangeOrg_MY",	
		"NG": "changeorgng",	
		"NI": "ChangeOrgCentro",
		"PA": "ChangeOrgCentro",
		"PE": "ChangeorgLatino",
		"PH": "ChangePilipinas",
		"PR": "ChangeorgLatino",
		"PY": "ChangeorgLatino",
		"RU": "ChangeOrgRus",
		"SV": "ChangeOrgCentro",
		"TH": "ChangeThailand",
		"TR": "ChangeTR",
		"UA": "changeorgrus",
		"US": "Change",
		"UY": "ChangeorgLatino",
		"VE": "ChangeorgLatino",
		"ZA": "ChangeorgSA"
	},
	"defaultHandle": "Change"
}
